// extracted by mini-css-extract-plugin
export var btn_container = "index-module--btn_container--b625a";
export var card_cover_container = "index-module--card_cover_container--26468";
export var card_footer_container = "index-module--card_footer_container--d1fad";
export var card_header_container = "index-module--card_header_container--2bd75";
export var problem_card = "index-module--problem_card--71236";
export var problem_solution_container = "index-module--problem_solution_container--2bfaf";
export var problem_title = "index-module--problem_title--892fb";
export var problem_with_pic = "index-module--problem_with_pic--89e0a";
export var problems_container = "index-module--problems_container--d6ebe";
export var problems_layout = "index-module--problems_layout--8f2b0";